export const LibraryTranslations = {
  libraryTranslations: {
    recentStories: 'Recent Stories',
    moreOn: 'More on',
  }
}